// removed by extract-text-webpack-plugin
module.exports = {"container":"_2ApYlkfoEO2uv6yky6anpX","containerHasDarkBg":"_2ScxjOPQ-3IdL6GkhAzj3d","containerHasLightBg":"_24q8HRexlptoEhoKLXMvO4","containerHasMinimalPadding":"nLtohv2ioMCQHEVKVCFjE","grid":"_3datLb1SPiJ_9XiLlDaRFT","headline":"_109SVpvfTQ7L1aTuYiKclh","copy":"_1nvgsG6YjPPgiS1ZIhaZVe","emailAddressContainer":"_11QbWROUxFOxHmzVwGabYu","emailAddress":"_1wTAdV_NJ3scUUtfLXxNjp","image":"_3nMYTtfLbYl0f8hw_GiDnj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Intro/styles.css
// module id = 305
// module chunks = 0